module.exports = __webpack_public_path__ + "static/media/CT_2019_30445A_pdf.9f7f3cc8.pdf";